import { SparklesIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';

type ImproveWritingButtonProps = {
    improveWriting: () => Promise<void>;
};

export function ImproveWritingButton({ improveWriting }: ImproveWritingButtonProps): ReactNode {
    const { t } = useLocale();

    const handleClick = async (): Promise<void> => {
        await improveWriting();
    };

    return (
        <Button
            icon={SparklesIcon}
            variant="secondary-ai"
            onMouseDown={(e) => {
                e.preventDefault();
            }}
            onClick={handleClick}
            aria-label={t('rich_text_editor__improve_writing')}
        >
            {t('rich_text_editor__improve_writing')}
        </Button>
    );
}

export default ImproveWritingButton;
